"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _WU47XUXMcjs = require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');


var _PFM4PJSGcjs = require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/dialog/dialog-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function DialogProvider(props = {}) {
  const store = _WU47XUXMcjs.useDialogStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _PFM4PJSGcjs.DialogContextProvider, { value: store, children: props.children });
}


exports.DialogProvider = DialogProvider;
